/**
 * Nested menu tools.
 */
const nested_menu_tools = function () {
    const submenu_opened_event = new Event('submenuopened');

    function getAllAncestors(menu, item, css_class) {
        let result = [];
        let ancestor = item.parentElement;
        while (ancestor && !ancestor.isEqualNode(menu)) {
            if (ancestor.classList.contains(css_class)) {
                result.push(ancestor);
            }
            ancestor = ancestor.parentElement;
        }
        return result;
    }

    function getAncestor(menu, item, css_class) {
        const result = getAllAncestors(menu, item, css_class);
        if (result.length) {
            return result[0];
        }
        return null;
    }

    function getMenuItemCaret(li) {
        return li.children[0].children[1].children[0];
    }

    function isElementInsideMenu(el) {
        while ((el = el.parentElement) !== null) {
            if (el.nodeType !== Node.ELEMENT_NODE) {
                continue;
            }
            if (el.isEqualNode(menu)) {
                return true;
            }
        }
        return false;
    }

    /**
     * Shows menu item children <li class="menu-item-has-children">
     */
    function activateMenuItem(menu, li) {
        // console.log('Activating menu item');

        // validate
        if (!li) {
            return;
        }

        const ul = li.children[1];
        if (ul) {
            li.classList.add('-open');

            let caret = getMenuItemCaret(li);
            if (caret) {
                caret.classList.add('-open');
                caret.setAttribute('aria-expanded', 'true');
            }

            ul.classList.add('-open');
            li.dispatchEvent(submenu_opened_event);
        }

        // activate parents <li> + <ul>
        const ancestors = getAllAncestors(menu, li, 'menu-item-has-children');
        for (let i = 0; i < ancestors.length; i++) {
            activateMenuItem(menu, ancestors[i]);
        }
    }

    /**
     * Hides menu item children <li class="menu-item-has-children">
     */
    function deactivateMenuItem(li) {
        // console.log('Deactivating menu item');

        // validate
        if (!li) {
            return;
        }

        li.classList.remove('-is-clicked');

        // deactivate <ul>
        const ul = li.children[1];
        if (ul) {
            li.classList.remove('-open');

            let caret = getMenuItemCaret(li);
            if (caret) {
                caret.classList.remove('-open');
                caret.setAttribute('aria-expanded', 'false');
            }

            ul.classList.remove('-open');
            ul.classList.remove('-is-out-of-bounds-right');
            ul.classList.remove('-is-out-of-bounds-bottom');
            ul.classList.remove('-is-out-of-bounds-top-and-bottom');
        }

        // deactivate children <li> + <ul>
        const children = li.querySelectorAll('.menu-item-has-children');
        for (let i = 0; i < children.length; i++) {
            deactivateMenuItem(children[i]);
        }
    }

    /**
     * Toggles the supplied menu item.
     *
     * @return int An integer value indicating the result of the toggle, where -1 = closed, 0 = failure, 1 = opened
     */
    function toggleMenuItem(menu, li) {
        // console.log('Toggling menu item');

        if (!li) {
            return 0;
        }

        if (li.classList.contains('-open')) {
            deactivateMenuItem(li);
            return -1;
        } else {
            activateMenuItem(menu, li);
            return 1;
        }
    }

    /**
     * Reset all menu-items' state.
     */
    function resetMenuItems(menu) {
        const items_with_children = menu.querySelectorAll(
            '.menu-item-has-children'
        );
        for (let i = 0; i < items_with_children.length; i++) {
            deactivateMenuItem(items_with_children[i]);
        }
    }

    // make the call chainable
    return {
        getAllAncestors: getAllAncestors,
        getAncestor: getAncestor,
        isElementInsideMenu: isElementInsideMenu,
        activateMenuItem: activateMenuItem,
        deactivateMenuItem: deactivateMenuItem,
        toggleMenuItem: toggleMenuItem,
        resetMenuItems: resetMenuItems,
    };
};

// Store tools in window
window.nested_menu_tools = nested_menu_tools();
